import styled from 'styled-components';

import { BLACK, WHITE, PAGE_WIDTH } from '@/styles/variables.style';
import media from '@/styles/media.style';

export const Section = styled.section`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

export const Item = styled.div`
  padding: 0 10px;
`;

export const SnsLinksSection = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 110px;

  ${media.tabletL`
    margin-bottom: 120px;
  `};
`;

export const SnsLink = styled.div`
  min-width: 90px;
  text-align: center;

  &.fbIcon {
    padding-right: 40px;
  }

  &.twIcon {
    padding-left: 40px;
  }
`;

export const IconWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

export const SnsLinkWrapper = styled.div`
  width: 100%;
    > a {
      color: ${BLACK};
      font-size: 14px;
      line-height: 16px;
      text-decoration: underline;
    }z
  }
`;

export const Linker = styled.a`
  // color: ${BLACK};
  // font-size: 14px;
  // line-height: 16px;
  // text-decoration: underline;
`;

export const Icon = styled.img`
  width: 50px;
  height: 50px;
`;



// WEBPACK FOOTER //
// ./src/components/SocialShare/SocialShare.style.js